/**
 * Reducer for board hotels
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import produce from 'immer'
import {
  FETCH_HOTEL_DETAILS,
  FETCH_HOTELS_FOR_LAT_LNG
} from 'client/app/js/services/hotels/types'

const initialState = {}

/**
 * Updates the hotels list with the properly updated hotel data
 */
const updateHotelData = (allHotels = [], locationId, hotelData = {}) => {
  const index = allHotels.findIndex((hotel) => hotel?.taid === locationId)

  if (index !== -1) {
    allHotels[index] = hotelData
  } else {
    allHotels.push(hotelData)
  }

  return allHotels
}

export default produce((draft, action) => {
  const bid = draft.currentBoard

  switch (action.type) {
    case FETCH_HOTEL_DETAILS:
      const { locationId, data } = action
      const updatedAllHotels = updateHotelData([...(draft[bid].hotels?.all || [])], locationId, data)

      draft[bid].hotels = {
        ...(draft[bid].hotels || {}),
        all: updatedAllHotels
      }

      break
    case FETCH_HOTELS_FOR_LAT_LNG:
      const allHotels = [...(draft[bid].hotels?.all || [])]
      const updtaedHotelResults = action.data?.data || []

      updtaedHotelResults.forEach((hotelData) => {
        updateHotelData(allHotels, hotelData?.taid, hotelData)
      })

      // Store history set of all fetched hotels
      draft[bid].hotels = {
        all: [
          ...allHotels,
          ...(action.data?.data || [])
        ],
        ...action.data
      }
      break
  }
}, initialState)
